"use client";

import Link from "next/link";
import Image from "next/image";
import { landingPage } from "@/styles/styles";

export default function EntryPage() {
  return (
    <div className={landingPage.shell}>
      {/* Top Bar */}
      <div className={landingPage.header}>
        <div>
          <Image src="/logo.png" alt="Logo" width={300} height={300} unoptimized />
        </div>
        <div>
          <Link href="/login">
            <button className={landingPage.loginButton}>
              Login
            </button>
          </Link>
        </div>
      </div>

      {/* Main Content */}
      <main className={landingPage.main}>
        {/* Subheading */}
        <h2 className={landingPage.tagline}>
          EDUCATE, EVALUATE, EXCEL
        </h2>

        {/* Main Heading with Graphics */}
        <div className={landingPage.headingWrap}>
          {/* Graphic Left */}
          <div className={landingPage.graphicLeft}>
            <Image
              src="/graphics.svg"
              alt="Graphic Left"
              width={40}
              height={40}
            />
          </div>

          {/* Graphic Right */}
          <div className={landingPage.graphicRight}>
            <Image
              src="/graphics1.svg"
              alt="Graphic Right"
              width={30}
              height={30}
            />
          </div>

          <h2 className={landingPage.heading}>
            <span className={landingPage.headingLine}>
              Data-Driven Insights
            </span>
            <span className={landingPage.headingLine}>
              for Infinite Possibilities
            </span>
          </h2>
        </div>

        {/* Paragraph */}
        <p className={landingPage.description}>
          Aralin Insights, powered by AI-driven analytics, transforms student
          performance data into smarter educational decisions.
        </p>

        {/* Sign Up Button */}
        {/* <Link href="/register">
          <button className={landingPage.signupButton}>
            Sign Up Now!
          </button>
        </Link> */}

        {/* Bottom Graphic */}
        <div className={landingPage.bottomGraphicWrap}>
          <div className={landingPage.bottomGraphic}>
            <Image
              src="/graphics2.svg"
              alt="Bottom Graphic"
              width={1500}
              height={1500}
            />
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className={landingPage.footer}>
        <div className={landingPage.footerCopy}>
          © 2025{" "}
          <span className={landingPage.brand}>
            Aralin Insights
          </span>{" "}
          — All rights reserved.
        </div>
        <div>
          <Link href="/privacy-terms">
            <span className={landingPage.footerLink}>
              Privacy Policy
            </span>
          </Link>
        </div>
      </footer>
    </div>
  );
}
